





























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import * as def from "@/definitions";

import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { ImageLayer } from "@/model/document2/page/surface/design/layer/imageLayer";
import { VectorImageLayer } from "@/model/document2/page/surface/design/layer/vectorImageLayer";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { MathHelper } from "@/helper/mathHelper";
import { ResourceHelper } from "@/helper/resourceHelper";

@Component({
  components: {
    RangeSlider,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class MultipleImageStyle extends Vue {
    @Prop() private design!: Design;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    multipleImageStyleContentsOpenAnimate = false;
    multipleImageStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.multipleImageStyleContentsCloseAnimate = true;
        setTimeout(() => {
            this.multipleImageStyleContentsCloseAnimate = false;
            this.multipleImageStyleContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.multipleImageStyleContentsOpenAnimate = true;
        setTimeout(() => {
            this.multipleImageStyleContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // すべてのレイヤーの特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getLayerProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof ImageLayer)
            {
                var val = layer[property];
                if(val != null)
                {
                    if(value == null) { value = val; }
                    else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                    else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                    else if(value === val) { value = val; }
                    else
                    {
                        isBreak = true;
                        break;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    private get opacity()
    {
        var value = this.getLayerProperty("opacity");
        return value != null && typeof(value) == "number" ? value : 100;
    }
    private get opacitySliderValue() { return this.opacity; }
    private set opacitySliderValue(value)
    {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value)
    {
        this.changeLayerProperty(value, "opacity", true);
    }

    private get colorFilterR()
    {
        var value = this.getLayerProperty("colorFilterR");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get colorFilterRSilderValue() { return this.colorFilterR; }
    private set colorFilterRSilderValue(value)
    {
        this.changeLayerProperty(value, "colorFilterR", false);
    }
    private onChangeColorFilterR(value)
    {
        this.changeLayerProperty(value, "colorFilterR", true);
    }

    private get colorFilterG()
    {
        var value = this.getLayerProperty("colorFilterG");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get colorFilterGSilderValue() { return this.colorFilterG; }
    private set colorFilterGSilderValue(value)
    {
        this.changeLayerProperty(value, "colorFilterG", false);
    }
    private onChangeColorFilterG(value)
    {
        this.changeLayerProperty(value, "colorFilterG", true);
    }

    private get colorFilterB()
    {
        var value = this.getLayerProperty("colorFilterB");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get colorFilterBSilderValue() { return this.colorFilterB; }
    private set colorFilterBSilderValue(value)
    {
        this.changeLayerProperty(value, "colorFilterB", false);
    }
    private onChangeColorFilterB(value)
    {
        this.changeLayerProperty(value, "colorFilterB", true);
    }

    private get blur()
    {
        var value = this.getLayerProperty("blur");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get blurSliderValue() { return this.blur; }
    private set blurSliderValue(value)
    {
        this.changeLayerProperty(value, "blur", false);
    }
    private onChangeBlur(value)
    {
        this.changeLayerProperty(value, "blur", true);
    }

    private get ratioFixed()
    {
        var value = this.getLayerProperty("keepRatio");
        return value != null && typeof(value) == "number" ? value == 0 : false;
    }

    private ratioFixChange()
    {
        var newValue = this.ratioFixed ? 1 : 0;
        this.changeLayerProperty(newValue, "keepRatio", true, true);
    }

    private get whiteToTransparent()
    {
        var value = this.getLayerProperty("whiteTransparent");
        return value != null && typeof(value) == "boolean" ? value : false;
    }

    private whiteToTransparentChange()
    {
        this.changeLayerProperty(!this.whiteToTransparent, "whiteTransparent", true, true);
    }

    private get flipHorizontal()
    {
        var value = this.getLayerProperty("flipHorizontal");
        return value != null && typeof(value) == "boolean" ? value : false;
    }

    private flipHorizontalChange()
    {
        this.changeLayerProperty(!this.flipHorizontal, "flipHorizontal", true, true);
    }

    private get flipVertical()
    {
        var value = this.getLayerProperty("flipVertical");
        return value != null && typeof(value) == "boolean" ? value : false;
    }

    private flipVerticalChange()
    {
        this.changeLayerProperty(!this.flipVertical, "flipVertical", true, true);
    }


    private changeLayerProperty(value: any, propertyName: string, isFinish : boolean = false, isOnce : boolean = false)
    {
        var layers = this.design.getSelectLayerWithoutGroup();

        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];

            this.$emit("doCommand", "changeLayerProperty", {
                layer : layer,
                propertyName : propertyName,
                value : value,
                isFinish : (isFinish || isOnce) && i == layers.length - 1,
                isOnce : false
            });
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
